<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <hos_state_apply_detail :state="state"></hos_state_apply_detail>
        <div class="pt15 pl15 pr15 pb15 flex">
            <div class="flex1 pr15">
                <hos_patient_info_detail :detail="detailObj"></hos_patient_info_detail><!-- 患者基本信息(不可填写) -->
                <hos_disease_info_detail class="mt20" :from="from" :detail="detailObj" ref="disease"></hos_disease_info_detail><!-- 病情基本信息(不可填写) -->
            </div>
            <div class="flex1 blshow pl15">
                <hos_doc_info_detail :detail="detailObj"></hos_doc_info_detail><!-- 申请医生信息 -->
                <hos_appointment_info_detail class="mt20" :state="detailObj.referralStatus" :detail="detailObj"><!-- 预约信息 -->
                    <template v-if="from == 'init'">
                        <template slot="buttonGroup" v-if="state == 'WAIT_EXAMINE'">
                            <hos_button content="取消预约" @clickEvent="showDialog('cancle')"></hos_button>
                            <hos_button content="确定上传" type="affirm" class="ml80" @clickEvent="loadUpMixin"></hos_button>
                        </template>
                        <template slot="buttonGroup" v-if="state == 'FINSH'">
                            <hos_button content="确定上传" type="affirm" @clickEvent="loadUpMixin"></hos_button>
                        </template>
                        <template slot="buttonGroup" v-if="state == 'CANCEL' || state == 'REFUSED'">
                            <hos_button content="再次申请" type="affirm" @clickEvent="applyAgainMixin"></hos_button>
                        </template>
                    </template>
                    <template v-else>
                        <template slot="buttonGroup" v-if="state == 'WAIT_EXAMINE'">
                            <hos_button content="拒绝转诊并书写理由" @clickEvent="showDialog('refuse')"></hos_button>
                            <hos_button content="同意转诊并确认时间" type="affirm" class="ml80" @clickEvent="showDialog('affirm')"></hos_button>
                        </template>
                        <template slot="buttonGroup" v-if="state == 'FINSH'">
                            <hos_button content="修改安排检查时间" type="affirm" @clickEvent="showDialog('update')"></hos_button>
                        </template>
                    </template>
                    <hos_cancle_info_detail v-if="(state == 'CANCEL' || state == 'REFUSED')" :state="state" slot="cancle"><!-- 拒绝或者取消原因 -->
                        <span slot="cancle_content">
                            {{this.detailObj.refuseReason}}
                        </span>
                    </hos_cancle_info_detail>
                </hos_appointment_info_detail><!-- 预约信息 -->
                <!-- 安排页面弹出框 -->
                <hos_dialog_detail ref="detail_dialog"
                    @refuse="refuseMixin"  @affirm="affirmMixin" @update="updateMixin" @cancle="cancleMixin"
                ></hos_dialog_detail>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumb from "../../components/common/Breadcrumb"
    import hos_state_apply_detail from "../../components/hos/hos-state-apply-detail"
    import hos_patient_info_detail from "../../components/hos/hos-patient-info-detail"
    import hos_disease_info_detail from "../../components/hos/hos-disease-info-detail"
    import hos_doc_info_detail from "../../components/hos/hos-doc-info-detail"
    import hos_appointment_info_detail from "../../components/hos/hos-appointment-info-detail"
    import hos_cancle_info_detail from "../../components/hos/hos-cancle-info-detail"
    import hos_button from '../../components/hos/hos-button'
    import hos_dialog_detail from '../../components/hos/hos-dialog-detail'
    import {initMixin} from '../../lib/mixins/hosInit'
    import {acceptMixin} from '../../lib/mixins/hosAccept'
    import {hosService} from '../../lib/service/hos'
    export default {
        name: "detail",
        components:{
            Breadcrumb,
            hos_state_apply_detail,
            hos_patient_info_detail,
            hos_disease_info_detail,
            hos_doc_info_detail,
            hos_appointment_info_detail,
            hos_button,
            hos_cancle_info_detail,
            hos_dialog_detail
        },
        mixins:[initMixin,acceptMixin],//会诊申请 和 会诊安排的混入对象
        data(){
            return {
                pages:[this.$route.params.type == 'check' ? "检查转诊" : "日间手术转诊",this.$route.query.from == 'accept' ? "转诊安排" : "转诊申请"],
                state:"",
                orderId:"",//详情单号查询
                detailObj:{},
                from:""//上级列表页类型
            }
        },
        methods:{
            //显示弹出框
            showDialog(type){
                this.$refs['detail_dialog'].start(type);
            },
            //查询详情
            async queryDetail(){
               this.detailObj = await hosService.queryDetail({
                    id:this.orderId
               })
                //转诊单状态
                this.state = this.detailObj.referralStatus;
            },
            setDetail(obj){
                this.detailObj  = Object.assign({},this.detailObj,obj);
                this.state = this.detailObj.referralStatus;
            }
        },
        created() {
            this.from = this.$route.query.from;//上一级页面来源
            this.orderId = this.$route.params.id;//获取路由上的单号参数
            this.queryDetail();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/hos";
</style>